"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShotDetailEnum = void 0;
var ShotDetailEnum;
(function (ShotDetailEnum) {
    ShotDetailEnum["DRIVE"] = "DRIVE";
    ShotDetailEnum["DRIVE_VOLLEY"] = "DRIVE_VOLLEY";
    ShotDetailEnum["DROP_SHOT"] = "DROP_SHOT";
    ShotDetailEnum["GROUND_STROKE"] = "GROUND_STROKE";
    ShotDetailEnum["HALF_VOLLEY"] = "HALF_VOLLEY";
    ShotDetailEnum["LOB"] = "LOB";
    ShotDetailEnum["PASSING_SHOT"] = "PASSING_SHOT";
    ShotDetailEnum["SMASH"] = "SMASH";
    ShotDetailEnum["TRICK"] = "TRICK";
    ShotDetailEnum["VOLLEY"] = "VOLLEY";
})(ShotDetailEnum || (exports.ShotDetailEnum = ShotDetailEnum = {}));
//# sourceMappingURL=shot_detail.js.map